// src/features/dashboard/components/AdminSummaryCard.tsx

import React from 'react';


type AdminSummaryCardProps = {
  title: string;

  value: number;

  suffix?: string;

  icon:
    React.ReactNode;
};


const AdminSummaryCard:
  React.FC<
    AdminSummaryCardProps
  > = ({
    title,
    value,
    suffix,
    icon,
  }) => {
    return (
      <article className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm sm:p-5">

        <div className="flex items-center justify-between">

          <span className="text-sm font-semibold text-gray-500">
            {title}
          </span>


          <span className="grid h-9 w-9 place-items-center rounded-xl bg-main/10 text-main">
            {icon}
          </span>

        </div>


        <div className="mt-4 flex items-baseline gap-1">

          <strong className="text-2xl font-black text-gray-900 sm:text-3xl">
            {value.toLocaleString()}
          </strong>


          {suffix && (
            <span className="text-sm text-gray-400">
              {suffix}
            </span>
          )}

        </div>

      </article>
    );
  };


export default AdminSummaryCard;